import { UnstyledTitle } from '~/elements/Title/Title';
import { LEGACY } from '~/utils/constants';

export const Heading = ({ headingText, subTitleText }: { headingText: string; subTitleText: string }) => {
  return (
    <>
      {LEGACY ? (
        <div className="Form__label">{headingText}</div>
      ) : (
        <UnstyledTitle as="h3" style={{ marginBottom: 0, lineHeight: 1.8, fontWeight: '600' }}>
          {headingText}
        </UnstyledTitle>
      )}
      <p
        style={{ margin: '0px 0px 1.25em 0px', fontFamily: 'Montserrat', lineHeight: 1.4, color: 'rgb(143, 143, 143)' }}
      >
        {subTitleText}
      </p>
    </>
  );
};
